import { Component, ViewChild, OnInit, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute, Params, NavigationEnd } from '@angular/router';
import { Location } from '@angular/common';
import { CourseService } from '../shared/services/course.service';
import { TagService } from '../shared/services/tag.service';
import { Course } from '../shared/models/course.model';
import { Tag } from '../shared/models/tag.model';
import { TagCategory } from '../shared/models/tag-category.model';

import 'rxjs/add/operator/filter';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/mergeMap';

import { KSSwiperContainer, KSSwiperSlide } from 'angular2-swiper';

@Component({
	selector: 'course-detail',
	templateUrl: './course-detail.component.html',
	styleUrls: ['./course-detail.component.scss']
})
export class CourseDetailComponent implements OnInit {
	// this is how you get access to the child component
	@ViewChild(KSSwiperContainer) swiperContainer: KSSwiperContainer;

	constructor(
		private courseService: CourseService,
		private tagService: TagService,
		private activatedRoute: ActivatedRoute,
		private router: Router,
		private location: Location
	) {
		this.gallerySwipeOptions = {
			slidesPerView: 1,
			loop: true,
			pagination: '.swiper-gallery-pagination',
			paginationType: 'fraction',
			a11y: true,
			nextButton: '.swiper-next',
			prevButton: '.swiper-prev'
		};
	}

	gallerySwipeOptions: any;
	selectedTagsFromCategories: TagCategory[] = new Array<TagCategory>();
	course: Course;
	hasTaggedCourses: boolean = false;
	selectedCourses: Array<Course>;
	tagUpdatedSubscription;
	galleryHasValidImages = true;

	ngOnInit(): void {
		this.activatedRoute.data.subscribe((data: { courseDetail: Course }) => {
			if (data.courseDetail) {
				this.course = data.courseDetail;
				if (this.swiperContainer && this.swiperContainer.swiper) {
          this.swiperContainer.swiper.destroy();
          this.swiperContainer.swiper = null;
          this.swiperContainer.ngOnInit();
				}
			}
		});

		// get tag categories for tag bar
		this.selectedTagsFromCategories = this.tagService.populatedTagCategories;

		// set selected courses for bottom navbar
		this.setTaggedCourse();

		// add tagupdated event for bottom navbar
		this.tagUpdatedSubscription = this.tagService.tagUpdated.subscribe(
			item => this.setTaggedCourse(item)
		);
	}

	ngOnDestroy(): void {
		this.tagUpdatedSubscription.unsubscribe();
	}

	getCoursesByTag(tag: Tag): Course[] {
		let courseArray = this.courseService.getCoursesByTag(tag);
		return courseArray;
	}

	toggleTagAccordian(tag: Tag, forceOpen: boolean = false): void {
		if (forceOpen) {
			tag.expanded = true;
		} else {
			tag.expanded = !tag.expanded;
		}
		this.course.tags.forEach((courseTag, j, array) => {
			if (courseTag != tag) {
				courseTag.expanded = false;
			}
		});
	}

	goBack(): void {
		this.location.back();
	}

	backToTop(): void {
		window.scrollTo(0, 0);
	}

	updateCourse(newCourse: Course): void {
		if (this.swiperContainer && this.swiperContainer.swiper) {
			Array.from(this.swiperContainer.swiper.slides).forEach(x => {
				const n: HTMLElement = x as HTMLElement;
				n.classList.remove('swiper-slide-duplicate-next');
				n.classList.remove('swiper-slide-duplicate-prev');
				if (n.classList.contains('swiper-slide-duplicate')) {
					n.remove();
				}
			});
		}
		this.router.navigate(['/course-detail', newCourse.id]);
	}

	setTaggedCourse(item = null): void {
		this.selectedCourses = this.courseService.getSelectedCourses();

		if (this.selectedCourses.find(el => el.relevancy > 0)) {
			this.hasTaggedCourses = true;
		} else {
			this.hasTaggedCourses = false;
		}
	}
}



// WEBPACK FOOTER //
// C:/dev/um.stamps/src/app/course-detail/course-detail.component.ts